export class Constants {
  public static DEFAULT_LANGUAGE = 'hu';
  public static SYSTEM_LANGUAGES = ['hu', 'en'];

  public static STORAGE_KEYS = {
    RESTAURANT:'RESTAURANT',
    LANGUAGE: 'LANGUAGE',
    RESERVATION_ARCHIVE_LIST: 'RESERVATION_ARCHIVE_LIST'
  }

  static ENVIRONMENT = "RESTAURANT";

  public static RESERVATION_TYPES = {
    "DELIVERY": "DELIVERY",
    "PERSONAL": "PERSONAL",
    "GROUP": "GROUP",
    "EXTRA": "EXTRA"
  };

  public static SYSTEM_ADMIN_RULE = 'superAdmin';

  public static QUERY_PARAMS = {
    LANGUAGE:'lang',
    CURRENCY:'currency',
    RESTAURANT:'restaurantHistoryId'
  };

  public static PUSH_NOTIFICATION_TYPES = {
    ADD_RESERVATION: "ADD_RESERVATION",
    ADD_DELIVERY:"ADD_DELIVERY",
    UPDATE_RESERVATION: "UPDATE_RESERVATION",
    UPDATE_DELIVERY: "UPDATE_DELIVERY",
    ADD_NOTE: "ADD_NOTE",
    STATUS_CHANGE_DELIVERY: "STATUS_CHANGE_DELIVERY",
    STATUS_CHANGE_ACCEPT: "STATUS_CHANGE_ACCEPT",
    STATUS_CHANGE_PENDING: "STATUS_CHANGE_PENDING",
    STATUS_CHANGE_SUCCESS: "STATUS_CHANGE_SUCCESS",
    STATUS_CHANGE_NOT_ARRIVED: "STATUS_CHANGE_NOT_ARRIVED",
    STATUS_CHANGE_DECLINE: "STATUS_CHANGE_DECLINE",
    UPDATE_GUEST: "UPDATE_GUEST",
    POSTPONE_RESERVATION: "POSTPONE_RESERVATION",
  };
}
